<template>
  <div id="app">

    <frameHeader/>

    <div class="pb-5">
      <keep-alive>
        <router-view v-if="$route.meta && $route.meta.keep_alive"  :key="$route.fullPath"/>
      </keep-alive>
      <router-view v-if="!$route.meta || !$route.meta.keep_alive"  :key="$route.fullPath"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import frameHeader from '@/views/_frame/header.vue';
  import Footer from "@/views/_frame/footer";
  export default {
    name: 'App',
    components: {
      Footer,
      frameHeader,
    },
  }
</script>

<style lang="scss">
    body{
      font-family: 'poppinssemibold' !important;
    }

  /*@import '@/assets/css/bootstrap.css';*/
  /*@import '@/assets/css/main.scss';*/
</style>
